export default __webpack_public_path__ + "8e2bb41.png";